<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(limitar(usuario.name, 30)) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Email</strong></td>
            <td id="usuarioEmail">{{ usuario.email }}</td>
          </tr>
          <tr>
            <td><strong>Perfil</strong></td>
            <td id="usuarioPerfil">{{ usuario.perfil }}</td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td
              id="usuarioAtivo"
              :class="usuario.ativo ? 'text-success' : 'text-danger'"
            >
              {{ usuario.ativo ? 'Ativo' : 'Cancelado' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/usuario/cadastro/' + usuario._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" />
          Editar
        </RouterLink>
        <RouterLink
          v-if="verificaAcao('trocar_senha') || souEu(usuario._id)"
          data-test-id="link-auto-2"
          :to="'/usuario/nova-senha/' + usuario._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-key" />
          Trocar senha
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import Autenticacao from '@/servicos/Autenticacao'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import * as formatadores from '@/utils/formatadores'

const autenticacao = new Autenticacao()
const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'UsuarioFicha',
  props: {
    usuario: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
    souEu(id) {
      const usuarioLoagdo = autenticacao.getUsuario()
      return id === usuarioLoagdo._id
    },
  },
}
</script>
